import React from 'react';
import TrafficLightList from './TrafficLightList';
import EditModal from './EditModal';
import ControlModal from './ControlModal';
import ControlModalList from './ControlModalList';

const MainContent = ({
  activeTab,
  trafficLights,
  editingLight,
  controllingLight,
  controllingLights,
  error,
  searchTerm,
  viewMode,
  useSSE,
  setViewMode,
  onEdit,
  onControlSingle,
  onControlBatch: parentOnControlBatch,
  onDelete,
  onUpdateTrafficLight,
  onControlTrafficLight,
  setError,
  setEditingLight,
  setControllingLight,
  setControllingLights
}) => {
  // Wrapper cho onControlBatch để truyền callback
  const handleControlBatch = (lights, onComplete) => {
    parentOnControlBatch(lights, (success) => {
      //if (success) {
        setControllingLights(null); // Reset controllingLights sau khi thành công
      //}
      if (onComplete) onComplete(success); // Trả về kết quả cho TrafficLightList
    });
  };

  return (
    <main className="flex-1 p-2 main-container overflow-y-auto">
      {activeTab === 'home' && (
        <div className="flex flex-col md:flex-row h-full gap-4 home-layout">
          <div className="flex-1 overflow-y-auto">
            <h2 className="text-2xl font-bold mb-4">Danh sách đèn giao thông</h2>
            {error && <div className="text-red-500 mb-4">{error}</div>}
            {trafficLights.length === 0 && !error && <div className="text-gray-500 mb-4">Đang tải danh sách đèn.</div>}
            <div className="mb-4 flex space-x-2 buttonView">
              <button
                title="Xem dạng danh sách"
                onClick={() => setViewMode('list')}
                className={`px-4 py-2 rounded ${viewMode === 'list' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'} hover:bg-blue-600 hover:text-white`}
              >
                ☰
              </button>
              <button
                title="Xem dạng lưới"
                onClick={() => setViewMode('grid')}
                className={`px-4 py-2 rounded ${viewMode === 'grid' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'} hover:bg-blue-600 hover:text-white`}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="1" y="1" width="14" height="14" stroke="currentColor" strokeWidth="2" />
                  <line x1="8" y1="1" x2="8" y2="15" stroke="currentColor" strokeWidth="2" />
                  <line x1="1" y1="8" x2="15" y2="8" stroke="currentColor" strokeWidth="2" />
                </svg>
              </button>
            </div>
            <TrafficLightList
              trafficLights={trafficLights}
              viewMode={viewMode}
              onEdit={onEdit}
              onControlSingle={onControlSingle}
              onControlBatch={handleControlBatch}
              onDelete={onDelete}
              error={error}
              searchTerm={searchTerm}
              className="h-[calc(100%-2rem)]"
            />
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-bold mb-4">Bản đồ</h2>
            <iframe
              src="https://trafficlight.saigoniot.vn/dpt"
              className="map-iframe w-full h-[calc(100%-2rem)]"
              title="Map View"
              onLoad={(e) => {
                const iframe = e.target;
                try {
                  if (!iframe.contentDocument || iframe.contentDocument.body.innerHTML === '') {
                    setError('Không thể tải bản đồ');
                  }
                } catch (err) {
                  setError('Không thể tải bản đồ');
                }
              }}
            />
          </div>
        </div>
      )}
      {activeTab === 'traffic-lights' && (
        <div className="h-full">
          <h2 className="text-2xl font-bold mb-4">Danh sách đèn giao thông</h2>
          {error && <div className="text-red-500 mb-4">{error}</div>}
          {trafficLights.length === 0 && !error && <div className="text-gray-500 mb-4">Đang tải danh sách đèn.</div>}
          <div className="mb-4 flex space-x-2 buttonView">
            <button
              title="Xem dạng danh sách"
              onClick={() => setViewMode('list')}
              className={`px-4 py-2 rounded ${viewMode === 'list' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'} hover:bg-blue-600 hover:text-white`}
            >
              ☰
            </button>
            <button
              title="Xem dạng lưới"
              onClick={() => setViewMode('grid')}
              className={`px-4 py-2 rounded ${viewMode === 'grid' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'} hover:bg-blue-600 hover:text-white`}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect x="1" y="1" width="14" height="14" stroke="currentColor" strokeWidth="2" />
                <line x1="8" y1="1" x2="8" y2="15" stroke="currentColor" strokeWidth="2" />
                <line x1="1" y1="8" x2="15" y2="8" stroke="currentColor" strokeWidth="2" />
              </svg>
            </button>
          </div>
          <TrafficLightList
            trafficLights={trafficLights}
            viewMode={viewMode}
            onEdit={onEdit}
            onControlSingle={onControlSingle}
            onControlBatch={handleControlBatch}
            onDelete={onDelete}
            error={error}
            searchTerm={searchTerm}
            className="h-[calc(100%-2rem)]"
          />
        </div>
      )}
      {activeTab === 'map' && (
        <div className="h-full">
          <h2 className="text-2xl font-bold mb-4">Xem bản đồ</h2>
          {error && <div className="text-red-500 mb-4">{error}</div>}
          <iframe
            src="https://trafficlight.saigoniot.vn/dpt"
            className="map-iframe"
            title="Map View"
            onLoad={(e) => {
              const iframe = e.target;
              try {
                if (!iframe.contentDocument || iframe.contentDocument.body.innerHTML === '') {
                  setError('Không thể tải bản đồ');
                }
              } catch (err) {
                setError('Không thể tải bản đồ');
              }
            }}
          />
        </div>
      )}
      {activeTab === 'settings' && (
        <div>
          <h2 className="text-2xl font-bold mb-4">Cài đặt</h2>
          <p>Module cài đặt (coming soon)</p>
        </div>
      )}
      {editingLight && (
        <EditModal
          light={editingLight}
          onSave={onUpdateTrafficLight}
          onCancel={() => {
            setEditingLight(null);
          }}
        />
      )}
      {controllingLight && (
        <ControlModal
          light={controllingLight}
          onSave={onControlTrafficLight}
          onCancel={() => {
            setControllingLight(null);
          }}
        />
      )}
      {controllingLights && controllingLights.length > 0 && (
        <ControlModalList
          lights={controllingLights}
          onSave={onControlTrafficLight}
          onCancel={() => {
            setControllingLights(null);
          }}
        />
      )}
    </main>
  );
};

export default MainContent;